import { FaLayerGroup, FaChalkboardTeacher, FaPalette, FaShieldAlt } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaLayerGroup />, // Material Selection icon
    title: 'Material Selection',
    description: 'Offering an extensive selection of materials including hardwood, ceramic, and natural stone',
  },
  {
    id: 2,
    icon: <FaChalkboardTeacher />, // Design Consultation icon
    title: 'Design Consultation',
    description: 'Providing professional advice on material selection, design, and layout',
  },
  {
    id: 3,
    icon: <FaPalette />, // Custom Designs icon
    title: 'Custom Designs',
    description: 'Creating customized designs to suit your specific aesthetic and functional requirements',
  },
  {
    id: 4,
    icon: <FaShieldAlt />, // Durability Assurance icon
    title: 'Durability Assurance',
    description: 'Ensuring long-lasting durability and resilience of installed flooring, tiling, and paving',
  },
];

export default features;